import { render } from "./PaymentsApprovalHistory.vue?vue&type=template&id=549959df"
import script from "./PaymentsApprovalHistory.vue?vue&type=script&lang=js"
export * from "./PaymentsApprovalHistory.vue?vue&type=script&lang=js"

import "./PaymentsApprovalHistory.vue?vue&type=style&index=0&id=549959df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__